import React, { Fragment } from 'react';
import { Box, Link } from '@mui/material';
import useConfig from 'hooks/useConfig';
import useProductActions from 'FeatureModules/ProductPage/hooks/useProductActions';
import { Link as RouterLink } from 'react-router-dom';
import { Plus } from '@styled-icons/bootstrap/Plus';
import ProductSummaryCard from 'FeatureModules/ProductPage/Components/Tables/ProductSummaryCard';
import ProductSummarySkeleton from 'FeatureModules/ProductPage/Components/Tables/ProductSummarySkeleton';
import { CardContainer, ThemeButton, ItemCardSmall } from 'DesignSystem';
import { IProduct } from 'FeatureModules/ProductPage/types/product.types';
import PageSubTitle from 'Components/PageSubTitle';

interface IProps {
  products: IProduct[];
  loading?: boolean;
}

const HomeProductOverview: React.FC<IProps> = ({ products, loading }) => {
  const {
    handleCreateProduct,
    goToProductAnalytics,
    navigateToProductOverview,
    navigateToProductEditor,
  } = useProductActions();
  const { homeProductsMaxLength } = useConfig();

  return (
    <Box flex={1} data-testid="home-products-overview">
      <PageSubTitle title="Products Overview" mb={2}>
        <Box display="flex" alignItems="center" gap={2.5}>
          <Link
            component={RouterLink}
            to="/products/active"
            color="secondary"
            className="small"
            data-testid="link-see-all-products"
          >
            See all products
          </Link>
          <ThemeButton
            onClick={handleCreateProduct}
            startIcon={<Plus size={20} color="black" />}
            size="small"
            color="WHITE"
            data-testid="button-overview-create-new"
          >
            Add new
          </ThemeButton>
        </Box>
      </PageSubTitle>
      {loading && !products?.length ? (
        <Fragment>
          {[...Array(homeProductsMaxLength).keys()].map(key => (
            <CardContainer key={key} padding={1.5} mt={1}>
              <ProductSummarySkeleton loading />
            </CardContainer>
          ))}
        </Fragment>
      ) : (
        <Box data-testid="home-product-container">
          {products.map(product => (
            <ItemCardSmall
              key={product.id}
              onCardClick={() => navigateToProductOverview(product.id)}
              onClickEdit={() => navigateToProductEditor(product.id)}
              onClickAnalytics={() => goToProductAnalytics(product.id)}
            >
              <ProductSummaryCard product={product} />
            </ItemCardSmall>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default HomeProductOverview;
